/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/* prettier-ignore */


export enum FirebaseRouteType {
    GuardianAlert = 1,
    GuardianAlertHistory = 2,
    MgiTask = 3,
    RateLoad = 4,
    Download = 5,
    CarrierConnectJob = 6,
}